<template>
  <div>
    <BaseLayoutSpaced>
      <BaseFormGroup>
        <BaseFormLabel :for="`${_uid}-form_id`"> Field * </BaseFormLabel>

        <BaseFormSelect
          v-model="data.field"
          :options="options"
          :id="`${_uid}-form_id`"
          class="block"
        />
      </BaseFormGroup>
      <BaseFormGroup>
        <BaseFormLabel :for="`${_uid}-form_id`"> Value * </BaseFormLabel>

        <BaseFormTextarea v-model="data.value" rows="10" />
      </BaseFormGroup>
    </BaseLayoutSpaced>
  </div>
</template>

<script>
const allowedOptions = [
  {
    label: 'Notes',
    value: 'notes',
  },
];

export default {
  props: {
    projectUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    const option = allowedOptions.find(
      (allowedOption) => this.defaultData[allowedOption.value] !== undefined
    );

    return {
      loading: false,
      options: [...allowedOptions],
      data: {
        field: (option || { value: '' }).value,
        value: option ? this.defaultData[option.value] : '',
      },
    };
  },

  watch: {
    data: {
      deep: true,
      handler(data) {
        if (!data.field || !data.value) {
          this.$emit('update-props', null);
        } else {
          this.$emit('update-props', { [data.field]: data.value });
        }
      },
    },
  },
};
</script>
